import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import serverModule from './modules/Server'
import agreementModule from './modules/Agreement'
import userAccountModule from './modules/UserAccount'
import athleteModule from './modules/Athlete'
import sessionModule from './modules/Session'
import organizationModule from './modules/Organization'
import organizationUserAccountModule from './modules/OrganizationUserAccount'

import measurementModule from './modules/Measurement'
import dashboardModule from './modules/Dashboard'
import timelineModule from './modules/Timeline'

export const store = new Vuex.Store({

    // strict mode in the dev environment.
    //strict: process.env.NODE_ENV !== 'production',

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    },

    modules: {
        agreement: agreementModule,
        userAccount: userAccountModule,
        athlete: athleteModule,
        session: sessionModule,
        organization: organizationModule,
        organizationUserAccount: organizationUserAccountModule,
        measurement: measurementModule,
        dashboard: dashboardModule,
        server: serverModule,
        timeLine: timelineModule
    }
});